import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import CircularLoading from "./components/CircularLoading";
import ResponsiveDrawer from './components/ResponsiveDrawer';

function matchUser(permit: any, usertype: any) {
    let permitions = permit ? permit.split(',') : [];
    let permitted = false;
    for (let i = 0; i < permitions.length; i++) {
        permitted = usertype === permitions[i] ? true : false
        if (permitted) break;
    }
    return permitted;
}

function ProtectedRoute({ permit, children }: any) {
    const auth = useSelector(state => state.auth);
    const [checkedAuth, setCheckedAuth] = useState(false);

    useEffect(() => {
        if (auth.profile && auth.profile.uid) {
            setCheckedAuth(true);
        }
        if (auth.error && auth.error.msg && !auth.profile) {
            setCheckedAuth(true);
        }
    }, [auth.profile, auth.error])

    return (
        checkedAuth ?
            auth.profile && auth.profile.uid ?
                matchUser(permit, auth.profile.usertype) ? <ResponsiveDrawer>{children}</ResponsiveDrawer> : <Navigate to="/login" />
                : <Navigate to="/login" />
            : <CircularLoading />
    )
}

export default ProtectedRoute;